import React from 'react';
const ModalContext = React.createContext({
    modalStack: [],
    setModalStack: () => {},
});
export default ModalContext;